class Covidence.Collection extends Backbone.Collection

  initialize: (models, options) ->
    super
    @url = options.url if options && options.url
